import React from "react";
import { Stack, Text, Center, Box } from "@chakra-ui/react";
import "@fontsource/lora";
import "@fontsource/lora/400-italic.css";

import Partners from "./Partners";
import ArticleList from "../articleList/ArticleList";
import Species from "./Species";
import AboutSection from "../../content/AboutSection";
import AuthorsSection from "../../content/AuthorsSection";
import ReviewerSection from "../../content/ReviewerSection";
import ContactSection from "../../content/ContactSection";
import NewsList from "../news/NewsList";

const MainPage = (props) => {
  const { recent, popular, refs, speciesOptions, news } = props;
  const {
    popularArticlesRef,
    recentArticlesRef,
    aboutRef,
    authorsRef,
    reviewersRef,
    contactRef,
    speciesRef,
    partnersRef,
    newsRef,
  } = refs;

  return (
    <Stack justifyContent="center">
      <Center marginTop="100px">
        <Stack direction="horizontal">
          <Text fontFamily="Lora" color="#26428b" fontSize="9xl">
            &micro;P
          </Text>
          <Stack>
            <Center>
              <Text
                fontFamily="Lora"
                color="#26428b"
                textShadow="1px 2px 2px"
                fontSize="7xl"
              >
                microPublication Biology
              </Text>
            </Center>
            <Center>
              <Text
                fontFamily="Lora"
                fontStyle="italic"
                color="#26428b"
                textShadow="1px 2px 2px"
                fontSize="5xl"
              >
                get your data out, be cited
              </Text>
            </Center>
          </Stack>
        </Stack>
      </Center>

      <ArticleList
        articles={recent}
        label="Recent microPublications"
        loadMoreText="Load more microPublications..."
        articlesRef={recentArticlesRef}
        page={6}
      />

      <ArticleList
        articles={popular}
        label="Popular microPublications (PubMed Central Views)"
        loadMoreText="Load more microPublications..."
        articlesRef={popularArticlesRef}
        page={6}
      />

      <Species speciesRef={speciesRef} speciesOptions={speciesOptions} />
      <NewsList news={news} newsRef={newsRef} />

      <AboutSection aboutRef={aboutRef} />
      <AuthorsSection authorsRef={authorsRef} />
      <ReviewerSection reviewersRef={reviewersRef} />
      <Partners partnersRef={partnersRef} />
      <ContactSection contactRef={contactRef} />
    </Stack>
  );
};

export default MainPage;
